import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { Observable, map } from 'rxjs';
import { Pet } from '../models/pet.model';
import { convertSnaps } from './utils.service';

@Injectable({
  providedIn: 'root',
})
export class PetService {
  constructor(private db: AngularFireDatabase) {}

  findById(petId: string): Observable<Pet> {
    return this.db
      .object<Pet>(`${localStorage.getItem('appId')}_pets/${petId}`)
      .snapshotChanges()
      .pipe(map((snapshot) => convertSnaps<Pet>([snapshot])[0]));
  }

  findPetsByOwnerId(ownerId: string): Observable<Pet[]> {
    return this.db
      .list(`${localStorage.getItem('appId')}_pets`, (ref) =>
        ref.orderByChild('ownerId').equalTo(ownerId),
      )
      .snapshotChanges()
      .pipe(
        map((results) => convertSnaps<Pet>(results)),
        map((pets: Pet[]) => {
          return pets.sort((a, b) => a.name.localeCompare(b.name));
        }),
      );
  }
}
